(function () {
  if (!window.MB_PRICE_OVERRIDE_CONFIG) return;

  var config = window.MB_PRICE_OVERRIDE_CONFIG;
  var rules = config.rules || [];
  if (!rules.length) return;

  var WRITTEN_ATTR = 'data-mb-price-written';

  // Variant-level rules take priority over product-level rules for the same product.
  var ruleByVariantId = {};
  var ruleByProductId = {};
  rules.forEach(function (rule) {
    if (rule.variantIds && rule.variantIds.length) {
      rule.variantIds.forEach(function (id) {
        ruleByVariantId[String(id)] = rule;
      });
    } else {
      (rule.productIds || []).forEach(function (id) {
        ruleByProductId[String(id)] = rule;
      });
    }
  });

  function findRule(productId, variantId) {
    if (variantId && ruleByVariantId[String(variantId)]) return ruleByVariantId[String(variantId)];
    if (productId && ruleByProductId[String(productId)]) return ruleByProductId[String(productId)];
    return null;
  }

  // Handles period-decimal ($1,628.00), comma-decimal (1.628,00), and no-decimal ($79)
  function parseCents(text) {
    var cleaned = text.replace(/[^0-9.,]/g, '');
    if (/\.\d{2}$/.test(cleaned)) {
      return Math.round(parseFloat(cleaned.replace(/,/g, '')) * 100);
    }
    if (/,\d{2}$/.test(cleaned)) {
      return Math.round(parseFloat(cleaned.replace(/\./g, '').replace(',', '.')) * 100);
    }
    return parseInt(cleaned.replace(/[.,]/g, ''), 10) * 100;
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return Shopify.formatMoney(cents, Shopify.money_format);
    }
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function applyDiscount(cents, rule) {
    var value = Number(rule.discountValue) || 0;
    if (rule.discountType === 'percent_off') {
      return Math.max(0, Math.round(cents * (1 - value / 100)));
    }
    if (rule.discountType === 'set_price') {
      return Math.max(0, Math.round(value * 100));
    }
    return Math.max(0, cents - Math.round(value * 100));
  }

  function applyToElement(el, rule) {
    var currentCents = parseCents(el.textContent);
    if (isNaN(currentCents)) return;

    var lastWritten = el.getAttribute(WRITTEN_ATTR);
    if (lastWritten !== null && currentCents === parseInt(lastWritten, 10)) {
      // Nothing new since our last write - avoids re-discounting our own output every tick.
      return;
    }

    var newCents = applyDiscount(currentCents, rule);
    el.setAttribute(WRITTEN_ATTR, String(newCents));
    el.textContent = formatMoney(newCents);
  }

  function processPriceScope(scopeEl, productId, variantId) {
    var rule = findRule(productId, variantId);
    if (!rule) return;

    var singleEl = scopeEl.querySelector('[data-price-container] [data-price]');
    if (singleEl) applyToElement(singleEl, rule);

    // A range bound can only be adjusted for whole-product rules - a variant-specific
    // rule has no correct min/max representation without misleading the shopper.
    if (!(rule.variantIds && rule.variantIds.length)) {
      var minEl = scopeEl.querySelector('[data-price-container] [data-price-min]');
      var maxEl = scopeEl.querySelector('[data-price-container] [data-price-max]');
      if (minEl) applyToElement(minEl, rule);
      if (maxEl) applyToElement(maxEl, rule);
    }
  }

  function scanCollectionCards() {
    document.querySelectorAll('[data-mb-product-id]').forEach(function (card) {
      processPriceScope(card, card.getAttribute('data-mb-product-id'), card.getAttribute('data-mb-variant-id'));
    });
  }

  function scanPdp() {
    if (!config.pdpProductId) return;
    var pricing = document.querySelector('[data-product-pricing]');
    if (!pricing) return;
    var variantInput = document.querySelector('[data-variants]');
    var variantId = variantInput ? variantInput.value : null;
    processPriceScope(pricing, config.pdpProductId, variantId);
  }

  setInterval(function () {
    scanPdp();
    scanCollectionCards();
  }, 250);
})();
